import React from 'react'

import { Layout } from 'components/Layout'

import type { TablePaginationProps } from './TablePagination.types'
import TablePaginationActions from 'components/TablePagination/TablePaginationActions'
import RowsPerPage from 'components/TablePagination/RowsPerPage'

function TablePagination(props: TablePaginationProps): JSX.Element {
  const {
    variant = 'default',
    count,
    labelRowsPerPage = 'Rows per page:',
    onPageChange,
    onRowsPerPageChange,
    page,
    rowsPerPage = 50,
    rowsPerPageOptions = [10, 25, 50, 100],
    disabled = false,
    ...rest
  } = props

  return (
    <Layout.Group space="xl" align="center" justify="space-between" {...rest}>
      <RowsPerPage
        page={page}
        count={count}
        onRowsPerPageChange={onRowsPerPageChange}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        labelRowsPerPage={labelRowsPerPage}
        disabled={disabled || !count}
      />
      <TablePaginationActions
        variant={variant}
        page={page}
        onPageChange={onPageChange}
        rowsPerPage={rowsPerPage}
        count={count}
        disabled={disabled || !count}
      />
    </Layout.Group>
  )
}

export default TablePagination
